import React from 'react'
import QueryBuilder from 'react-querybuilder'
import { QueryBuilderDnD } from '@react-querybuilder/dnd'
import * as ReactDnD from 'react-dnd'
import * as ReactDndHtml5Backend from 'react-dnd-html5-backend'
import * as ReactDndTouchBackend from 'react-dnd-touch-backend'
import { AddRuleActionElement, RemoveRuleAction } from './ActionElements'
import JoinColumnsValueEditor from './JoinColumnsValueEditor'
import { CustomCombinatorSelector, CustomDragIcon, } from '../filters/ValueSelector'

const JoinsQueryBuilder = props => {
    return (
        // <QueryBuilderDnD
        //     dnd={{
        //         ...ReactDnD,
        //         ...ReactDndHtml5Backend,
        //         ...ReactDndTouchBackend,
        //     }}
        // >
            <QueryBuilder
                controlElements={{
                    inlineCombinator: CustomCombinatorSelector, // combinatorSelector: CustomCombinatorSelector, //combinator is not needed for independent-combinator style, instead we use inlineCombinator
                    fieldSelector: null,
                    operatorSelector: null,
                    valueEditor: JoinColumnsValueEditor,
                    addGroupAction: null,
                    removeGroupAction: null,
                    addRuleAction: AddRuleActionElement,
                    removeRuleAction: RemoveRuleAction,
                    // dragHandle: CustomDragIcon,
                }}
                addRuleToNewGroups
                showCombinatorsBetweenRules
                context={{
                    ...props.context,
                    sourceType: 'join',
                    viewOnly: props.viewOnly,
                }}
                {...props}
            />
        // </QueryBuilderDnD>
    )
}

export default JoinsQueryBuilder
